import { GetDashboardResponse } from '@blockworks/platform/api/research/studio';

import { findTopOrFeaturedVisualizations } from './find-top-visualizations';

const getPreloadableVisualizations = (dashboard: GetDashboardResponse['data']) => {
    if (!dashboard?.visualizations?.length) {
        console.error('Dashboard visualizations not found.', {
            visualizations: dashboard?.visualizations,
        });

        return [];
    }

    const { visualizations, layoutConfig, isPublic } = dashboard;

    const topVisualizations = findTopOrFeaturedVisualizations(
        { layoutConfig, visualizations, isPublic },
        {
            maxFeaturedVisualizations: 2,
            maxVisualizations: 1,
            maxVisualizationsForPublicDashboard: 2,
        },
    );

    return topVisualizations;
};

export { getPreloadableVisualizations };
